import React from 'react';
import { Collapse, List } from '@mui/material';
import { useSidebar } from '../hook/useSidebar';
import SidebarItem from '../SidebarItem';
import SidebarItemExpendable from '../SidebarItemExpendable';
import { LibraryBooks, LockOpen, LockOutline } from '@mui/icons-material';
import { usePermissionRules } from 'hooks/permissionRules';

const Surgeries: React.FC = () => {
  const { handleCollapseClick, collapsible } = useSidebar();
  const { checkPermission } = usePermissionRules();

  return (
    <>
      <SidebarItemExpendable
        onClick={() => handleCollapseClick('surgeries')}
        text="Orçamentos cirúrgicos"
        opened={collapsible.surgeries}
        icon={<LibraryBooks />}
      />
      <Collapse in={collapsible.surgeries}>
        <List disablePadding>
          {checkPermission('surgeries.open') && (
            <SidebarItem nested={5} to="/surgeries/open" icon={<LockOpen />} text="Abertos" />
          )}
          {checkPermission('surgeries.closed') && (
            <SidebarItem nested={5} to="/surgeries/closed" icon={<LockOutline />} text="Fechados" />
          )}
        </List>
      </Collapse>
    </>
  );
};

export default Surgeries;
